export default __webpack_public_path__ + "static/media/Visual 7.a46ede86.jpeg";